import { createAsyncThunk } from "@reduxjs/toolkit";
import { IInsurer } from "entities/cancer-protection/step-2/types/StepTwo-inerface";
import { getRequestProductSales } from "shared/utils/fetch-api";

export const fetchCreateInsuranceContractProjects = createAsyncThunk(
    'contract/fetchCreateInsuranceContractProjects',
    async ({
        BeginDate,
        Insurer,
        Insureds,
        RegionID,
        CalculationRequestID,
        ProgramsIDs,
        AgentSalesDataID
    }: {
        BeginDate: string;
        Insurer: IInsurer;
        Insureds: IInsurer[];
        RegionID: string;
        CalculationRequestID: string;
        ProgramsIDs: string[];
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            AgentSalesDataID: AgentSalesDataID,
            Source: "Site",
            BeginDate: BeginDate,
            Insurer: Insurer,
            Insureds: Insureds,
            RegionID: RegionID,
            CalculationRequestID: CalculationRequestID,
            Programs: ProgramsIDs
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'createInsuranceContractProjects', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    InvoiceID: data.Invoice.ID,
                    InvoicePayLink: data.Invoice.PayLink
                };
            } else {
               return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const fetchCreateInsuranceContracts = createAsyncThunk(
    'contract/fetchCreateInsuranceContracts',
    async ({
        InvoiceID,
        AgentSalesDataID
    }: {
        InvoiceID: string;
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site",
            "InvoiceID": InvoiceID
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'createInsuranceContracts', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Files: data.Files,
                    Insurer: data.Insurer,
                    Policies: data.Policies
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);